import {
	AfterViewInit,
	Component,
	Inject,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	SimpleChanges,
	ViewChild,
} from '@angular/core';
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog';
import {
	MatTableDataSource,
	MatTable,
	MatNoDataRow,
	MatColumnDef,
	MatHeaderCellDef,
	MatHeaderCell,
	MatCellDef,
	MatCell,
	MatHeaderRowDef,
	MatHeaderRow,
	MatRowDef,
	MatRow,
} from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { DeactivateUserDialogComponent } from 'src/app/components/deactivate-user-dialog/deactivate-user-dialog.component';
import { DataSetComponent } from 'src/app/components/data-set/data-set.component';
import { Company } from 'src/app/models/data/company';
import { Role } from 'src/app/models/data/role';
import { SystemCapabilityEnum } from 'src/app/models/data/systemCapability';
import { User } from 'src/app/models/data/user';
import { UserProfile } from 'src/app/models/model';
import { ApiLoadingKeys, ApiService } from 'src/app/services/api.services';
import { AuthService } from 'src/app/services/auth.service';
import { BannerMessageService } from 'src/app/services/banner-message.service';
import { LoadingIndicatorService } from 'src/app/services/loading-indicator.service';
import { SystemCapabilityService } from 'src/app/services/system-capabilities/system-capability.service';
import { MatDivider } from '@angular/material/list';
import { CdkScrollable } from '@angular/cdk/scrolling';
import {
	DataSetComponent as DataSetComponent_1,
	DataSetToolbarComponent,
	DataSetSearchActionGroupDirective,
	DataSetPrimaryActionGroupDirective,
	DataSetActionButtonComponent,
	DataSetSelectedActionGroupDirective,
	DataSetContentComponent,
} from '../../../../components/data-set/data-set.component';
import { DataSetSearchComponent } from '../../../../components/data-set/data-set-search.component';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import {
	DataSetTableComponent,
	DataSetTableRowSelectionComponent,
	DataSetTableMenuComponent,
	DataSetRowClickDirective,
} from '../../../../components/data-set/data-set-table.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatMenu, MatMenuContent, MatMenuItem } from '@angular/material/menu';
import { PhoneNumberPipe } from '../../../../components/pipes';
import { DataSetLoadingRowComponent } from '../../../../components/data-set/data-set-loading-row.component';

@Component({
	selector: 'app-role-detail-user-table',
	templateUrl: './role-detail-user-table.component.html',
	styleUrls: ['./role-detail-user-table.component.scss'],
	imports: [
		DataSetComponent_1,
		DataSetToolbarComponent,
		DataSetSearchActionGroupDirective,
		DataSetSearchComponent,
		MatFormField,
		MatLabel,
		MatInput,
		FormsModule,
		DataSetPrimaryActionGroupDirective,
		DataSetActionButtonComponent,
		DataSetSelectedActionGroupDirective,
		DataSetContentComponent,
		DataSetTableComponent,
		MatTable,
		MatSort,
		MatNoDataRow,
		MatColumnDef,
		MatHeaderCellDef,
		MatHeaderCell,
		MatCellDef,
		MatCell,
		DataSetTableRowSelectionComponent,
		MatSortHeader,
		DataSetTableMenuComponent,
		MatHeaderRowDef,
		MatHeaderRow,
		MatRowDef,
		MatRow,
		DataSetRowClickDirective,
		MatMenu,
		MatMenuContent,
		MatMenuItem,
		PhoneNumberPipe,
		DataSetLoadingRowComponent,
	],
})
export class RoleDetailUserTableComponent
	implements AfterViewInit, OnDestroy, OnInit, OnChanges
{
	@ViewChild(DataSetComponent) dataSet!: DataSetComponent;
	@Input() role!: Role;
	@Input() company?: Company;
	@Input() companyId = '';

	displayedColumns: string[] = [
		'rowSelection',
		'firstName',
		'lastName',
		'email',
		'phoneNumber',
		'active',
		'rowMenu',
	];
	dataSource = new MatTableDataSource<User>();
	private filterSubscription?: Subscription;
	private authSubscription?: Subscription;

	canEditRoles = false;
	currentUserId?: string;
	activeRoleId?: string;

	loggedInSubscription: any;
	companyIsSentrilock = false;

	viewInitialized = false;

	usersLoadedWithoutFilters?: User[];

	userDeactivationLabels = {
		singularUser: $localize`:@@deactivateUser-deactivateUserLabel:Deactivate User`,
		pluralUsers: $localize`:@@deactivateUser-deactivateUsersLabel:Deactivate Users`,
	};

	filterLabels = {
		defaultPlaceholder: $localize`:@@roleDetailUserTable-defaultPlaceholder:Search email...`,
		firstName: $localize`:@@roleDetailUserTable-filterOptionFirstName:First Name`,
		lastName: $localize`:@@roleDetailUserTable-filterOptionLastName:Last Name`,
		email: $localize`:@@roleDetailUserTable-filterOptionEmail:Email`,
		phoneNumber: $localize`:@@roleDetailUserTable-filterOptionPhoneNumber:Phone Number`,
		active: $localize`:@@roleDetailUserTable-filterOptionActive:Active`,
	};

	get selectedUsers(): User[] {
		return this.dataSet.selection.selected;
	}

	getAssignedRoleUsersLoadingKey = ApiLoadingKeys.getAssignedRoleUsers;
	finishedLoadingInitData: boolean = false;

	constructor(
		private readonly apiService: ApiService,
		private readonly router: Router,
		private readonly dialog: MatDialog,
		private readonly scService: SystemCapabilityService,
		private readonly bannerService: BannerMessageService,
		private readonly authService: AuthService,
		public readonly loadingService: LoadingIndicatorService
	) {
		this.authSubscription = this.authService.userSession().subscribe((it) => {
			this.currentUserId = it.claims?.user_id;
			this.activeRoleId = it.assignedRole?.roleId;
			this.setCanEditRoles();
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			this.companyId &&
			this.role.id &&
			!this.filterSubscription &&
			this.viewInitialized
		) {
			this.setUpFilterSubscription();
		}
	}

	async ngAfterViewInit(): Promise<void> {
		this.viewInitialized = true;
		if (this.role.id && this.companyId && !this.filterSubscription) {
			this.setUpFilterSubscription();

			if (!this.company) {
				this.apiService.getCompanyById(this.companyId).then((response) => {
					this.company = response.company;
				});
			}
		}
	}

	setUpFilterSubscription(): void {
		this.filterSubscription = this.dataSet.queryParams
			.pipe(
				mergeMap(async (filter) => {
					const requestFilters = [...filter, { param: 'active', value: 1 }];

					let originalRowCount = null;
					let newFilters;
					if (!this.usersLoadedWithoutFilters) {
						newFilters = requestFilters.map((f) => {
							if (f.param === 'rowIndex') {
								return { ...f, value: 0 };
							} else if (f.param === 'rowCount') {
								originalRowCount = f.value as number;
								return { ...f, value: 76 };
							}
							return f;
						});
					}

					this.finishedLoadingInitData = true;
					return {
						users: await this.apiService.getAssignedRoleUsers(
							this.role.id,
							this.companyId,
							newFilters ? newFilters : requestFilters
						),
						originalRowCount,
					};
				})
			)
			.subscribe((data) => {
				if (!this.usersLoadedWithoutFilters) {
					this.usersLoadedWithoutFilters = data.users;
					this.dataSource.data = data.users.slice(0, data.originalRowCount!);
				} else {
					this.dataSource.data = data.users;
				}
			});
	}

	async ngOnInit(): Promise<void> {
		await this.setCanEditRoles();
	}

	async setCanEditRoles(): Promise<void> {
		// TODO: Need to double-check all these checks when this page is used
		//       for screen: Companies -> [Some Company] -> Roles -> [Selected Role] -> Users

		const hasUserRoleManagement = this.scService.has(
			SystemCapabilityEnum.userRoleManagement
		);
		const hasGlobalCompanyMgmt = this.scService.has(
			SystemCapabilityEnum.globalCompanyManagement
		);
		const sentrilockId = await this.apiService.getSentrilockCompanyId();

		const userProfile: UserProfile = await this.apiService.getUserProfile();
		const activeCompanyId = userProfile?.activeRoleDetails?.company?.id;

		let editingCompanyId = this.company?.id;
		if (!editingCompanyId) {
			editingCompanyId = activeCompanyId;
		}

		const isEditingActiveCompany = activeCompanyId === editingCompanyId;
		this.companyIsSentrilock = editingCompanyId === sentrilockId;

		this.canEditRoles =
			(hasUserRoleManagement && isEditingActiveCompany) ||
			(hasGlobalCompanyMgmt && !this.companyIsSentrilock);

		// Only Oracles can edit Oracles
		if (this.role.isOracle && !this.scService.isOracle) {
			this.canEditRoles = false;
		}

		// Only Company Admins or Global Company Mgmt can edit Company Admins
		if (
			this.role.isCompanyAdmin &&
			!this.scService.isCompanyAdmin &&
			!hasGlobalCompanyMgmt
		) {
			this.canEditRoles = false;
		}
	}

	ngOnDestroy(): void {
		this.filterSubscription?.unsubscribe();
		this.filterSubscription = undefined;

		this.authSubscription?.unsubscribe();
		this.authSubscription = undefined;
	}

	onRowClick(user: User): void {
		this.router.navigate(['/user-detail', user.id]);
	}

	navigateToAddUsers(): void {
		this.router.navigateByUrl(`/roleDetail/${this.role.id}/add-user`, {
			state: { companyId: this.companyId },
		});
	}

	canAddUser(): boolean {
		if (this.role.isUniversal) {
			if (this.scService.isOracle) {
				// Oracles can always remove users
				return true;
			}
			if (this.role.isOracle) {
				// Only Oracles can remove Oracles
				return false;
			}
			if (this.role.isCompanyAdmin) {
				// Only CAs can remove other CAs
				return this.scService.isCompanyAdmin;
			}
			if (this.role.isSupport) {
				// Support is internal-only; URM on SentriLock can assign
				return this.canEditRoles;
			}

			// Shouldn't get here, since this.role.isUniversal should either be Oracle or CA
			console.error(
				'Unexpected code path! Role is Universal but not Oracle, Company Admin, or Support!'
			);
			return this.role.id === this.activeRoleId;
		} else {
			// If not a Universal role, than the standard canEditRoles checks apply
			return this.canEditRoles;
		}
	}

	canRemoveUser(user: User): boolean {
		// A user can never remove themselves from a role
		if (user.id === this.currentUserId) {
			return false;
		}

		// Other checks are the same as adding users
		return this.canAddUser();
	}

	removeUsers(users: User[]): void {
		if (
			this.role.isUniversal &&
			users.length >=
				(this.usersLoadedWithoutFilters
					? this.usersLoadedWithoutFilters.length
					: this.dataSource.data.length)
		) {
			const dialogRef: MatDialogRef<LastUserErrorDialogComponent> =
				this.dialog.open(LastUserErrorDialogComponent, {
					maxWidth: '510px',
					panelClass: 'pop-up-dialog-v2',
				});
		} else {
			this.openDeactivateUserDialog(users);
		}
	}

	openDeactivateUserDialog(users: User[]) {
		const dialogRef: MatDialogRef<DeactivateUserDialogComponent> =
			this.dialog.open(DeactivateUserDialogComponent, {
				maxWidth: '510px',
				panelClass: 'pop-up-dialog-v2',
				data: {
					users,
					roleName: this.role.name,
					company: this.company,
					roleId: this.role.id,
				},
			});

		// Clear both current page selection and persistent selections
		this.dataSet.clearAllSelections();

		dialogRef.afterClosed().subscribe((result: any) => {
			if (!!result) {
				// Clear both current page selection and persistent selections after successful deactivation
				this.dataSet.clearAllSelections();
				this.dataSet.applyFilters();
			}
		});
	}

	formatSelectedUserName(item: User): string {
		const firstName = item.firstName || '';
		const lastName = item.lastName || '';
		const lastNameInitial = lastName.charAt(0).toUpperCase();

		if (firstName && lastNameInitial) {
			return `${firstName} ${lastNameInitial}`;
		} else if (firstName) {
			return firstName;
		} else if (lastName) {
			return lastName;
		}

		return (
			item.email || $localize`:@@selectedDisplayFormat-unknownUser:Unknown User`
		);
	}

	rowId(row: User): string {
		return row?.id || 'unknown-id';
	}
}

@Component({
	selector: 'app-last-user-error-dialog',
	template: `
		<div class="pop-up-dialog-v2">
			<h3 i18n="@@deactivateUser-cannotRemoveTheLastUserErrorHeader">Error!</h3>
			<mat-divider></mat-divider>

			<mat-dialog-content>
				<div i18n="@@deactivateUser-cannotRemoveTheLastUserErrorDesc">
					You cannot remove the last user from this role.
				</div>
			</mat-dialog-content>

			<mat-dialog-actions>
				<button
					(click)="onOkClicked()"
					class="primary-small-button"
					i18n="@@deactivateUser-cannotRemoveTheLastUserErrorConfirm"
					data-automation-id="role-detail-user-ok-button"
				>
					Ok
				</button>
			</mat-dialog-actions>
		</div>
	`,
	styleUrls: [
		'./role-detail-user-table.component.scss',
		'../../../common/main.scss',
	],
	imports: [MatDivider, CdkScrollable, MatDialogContent, MatDialogActions],
})
export class LastUserErrorDialogComponent {
	constructor(private dialogRef: MatDialogRef<LastUserErrorDialogComponent>) {}

	onOkClicked(): void {
		this.dialogRef.close();
	}
}

@Component({
	selector: 'app-set-user-active-status-error-dialog',
	template: `
		<div class="pop-up-dialog-v2">
			<h3 i18n="@@setActiveStatusUser-cannotSetActiveStatusErrorHeader">
				Error!
			</h3>
			<mat-divider></mat-divider>

			<mat-dialog-content>
				<div>
					<ng-container i18n="@@setActiveStatusUser-assignRole"
						>Please assign a role before</ng-container
					>
					{{
						data.activatingUser
							? userActivationLabels.reactivating
							: userActivationLabels.deactivating
					}}
					<ng-container i18n="@@setActiveStatusUser-theUser"
						>the user.</ng-container
					>
				</div>
			</mat-dialog-content>

			<mat-dialog-actions>
				<button
					(click)="onOkClicked()"
					class="primary-small-button"
					i18n="@@setActiveStatusUser-cannotSetActiveStatusErrorConfirm"
					data-automation-id="role-detail-user-ok-two-button"
				>
					Ok
				</button>
			</mat-dialog-actions>
		</div>
	`,
	styleUrls: [
		'./role-detail-user-table.component.scss',
		'../../../common/main.scss',
	],
	imports: [MatDivider, CdkScrollable, MatDialogContent, MatDialogActions],
})
export class CannotSetActiveStatusErrorDialogComponent {
	userActivationLabels = {
		reactivating: $localize`:@@setActiveStatusUser-activatingUserLabel:reactivating`,
		deactivating: $localize`:@@setActiveStatusUser-deactivatingUsersLabel:deactivating`,
	};

	constructor(
		private dialogRef: MatDialogRef<LastUserErrorDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: CannotSetActiveStatusErrorDialogData
	) {}

	onOkClicked(): void {
		this.dialogRef.close();
	}
}

export interface CannotSetActiveStatusErrorDialogData {
	activatingUser?: boolean;
}
